import { createAction } from 'reflux';

const setLanguage = createAction();

export default setLanguage;



/** WEBPACK FOOTER **
 ** ./app/scripts/actions/lang.es6
 **/